import { AxiosError } from 'axios';

export type PlanError =
  | { code: 'PLAN_LIMIT'; resource: string; limit: number; used: number; plan: string }
  | { code: 'PLAN_FEATURE'; feature: string; plan: string };

/** Only a 402 is a plan error. 403s belong to tenantRecovery and must never open the modal. */
export function planErrorFrom(error: unknown): PlanError | null {
  const response = (error as AxiosError)?.response;
  if (response?.status !== 402) return null;
  const data = response.data as { code?: string } | undefined;
  return data?.code === 'PLAN_LIMIT' || data?.code === 'PLAN_FEATURE' ? (data as PlanError) : null;
}
